/**
 * Events — public event types (BrainEvent + variants) + EventBus utility.
 */
export * from '../shared/events.js';
export { EventBus } from '../shared/eventBus.js';
